import { Injectable } from '@angular/core';

@Injectable()
export class DynamicComponentsInjectedData {
    inputData: any;
}
